import { InternalServerErrorException } from '../../../../common/exceptions/exceptions';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { AccountAverageCallsPerWorkspaceTimeseriesAggregateRootMapper } from '../../../../infrastructure/mappers/org-metrics/calls/account-average-calls-per-workspace-time-series.aggregate-root.mapper';
import { GetAccountAverageCallsPerWorkspaceTimeseriesRequestDto } from '../../../dtos/org-metrics/calls/get-account-average-calls-per-workspace-time-series.request.dto';
import { GetAccountAverageCallsPerWorkspaceTimeseriesResponseDto } from '../../../dtos/org-metrics/calls/get-account-average-calls-per-workspace-time-series.response.dto';
import { GetAccountAverageCallsPerWorkspaceTimeseriesQuery } from '../../../queries/org-metrics/calls/get-account-average-calls-per-workspace-time-series.query';

export class GetAccountAverageCallsPerWorkspaceTimeseriesController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountAverageCallsPerWorkspaceTimeseriesQuery,
    protected readonly mapper: AccountAverageCallsPerWorkspaceTimeseriesAggregateRootMapper
  ) {}

  async get(
    props: GetAccountAverageCallsPerWorkspaceTimeseriesRequestDto
  ): Promise<GetAccountAverageCallsPerWorkspaceTimeseriesResponseDto> {
    try {
      const result = await this.query.execute(props);
      return result.map((res) => this.mapper.toResponse(res));
    } catch (error) {
      throw new InternalServerErrorException(
        `GetAccountAverageCallsPerWorkspaceTimeseriesController.get encountered an error ${error}`
      );
    }
  }
}
